import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import SupportUserDetailsInfo from "./SupportUserDetailsInfo";
import SupportUserDetailsTabsContainer from "./SupportUserDetailsTabsContainer";
import { StyledSupportUserDetailsWrapper } from "../../styledSupportUser";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { NavLink } from "react-router-dom";
import GoToBackButton from "../../../elements/goToBack/GoToBack";

const SupportUserDetailsContainer = ({ match }) => {
  const { t } = useTranslation("supportUserPage");
  const [supportUser, setSupportUser] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchSupportUser = () => {
    axios.get("/api/users/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setSupportUser(response.data);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchSupportUser();
  }, []);

  if (!supportUser) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledSupportUserDetailsWrapper>
        <Helmet>
          <title>
            {!supportUser.firstname || !supportUser.lastname ? t("details.meta.title") : `${supportUser.firstname} ${supportUser.lastname}`} • eXsoft.io</title>
        </Helmet>
        <SupportUserDetailsInfo
          user={supportUser}
          notification={notification}
          setNotification={setNotification}
        />
        <SupportUserDetailsTabsContainer
          match={match}
        />
      </StyledSupportUserDetailsWrapper>
    </>
  );
};

export default SupportUserDetailsContainer;